import { Component, Input, OnInit } from "@angular/core";
import { NG_VALUE_ACCESSOR } from "@angular/forms";
import { BaseFormFieldComponent } from "../base-form-field.component";
import {
  FirstTimePickupStepValues,
  LocalDeliveryStepValues,
  LocalPickupStepValues,
  Order,
  OrderStepForAnyServiceType,
  orderStepToString,
} from "src/services/order/order.interface";
import { PendingOrder } from "src/services/pending-order/pending-order.interface";
import { ServiceType } from "src/services/subscription/plan-service-type.enum";

@Component({
  selector: "rc-order-step-form-field",
  templateUrl: "./order-step-form-field.component.html",
  styleUrls: ["./order-step-form-field.component.scss"],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: OrderStepFormFieldComponent,
    },
  ],
  standalone: false,
})
export class OrderStepFormFieldComponent extends BaseFormFieldComponent<OrderStepForAnyServiceType> implements OnInit {
  @Input() public order: Order | PendingOrder;
  @Input() public withLabel: boolean = false;

  public orderStepValues: OrderStepForAnyServiceType[];

  constructor() {
    super();
  }

  public async ngOnInit(): Promise<void> {
    if (this.order?.serviceType === ServiceType.firstTimePickup) {
      this.orderStepValues = Object.values(FirstTimePickupStepValues);
    } else if (this.order?.serviceType === ServiceType.localDelivery) {
      this.orderStepValues = Object.values(LocalDeliveryStepValues);
    } else if (this.order?.serviceType === ServiceType.localPickup) {
      this.orderStepValues = Object.values(LocalPickupStepValues);
    }
    super.ngOnInit();
  }

  public async onInputChange(event: unknown): Promise<void> {
    const ionEvent = event as CustomEvent;

    const inputValue = ionEvent.detail.value;

    await this.onInputChangeInternal(inputValue);
  }

  protected async toDisplayValue(input: OrderStepForAnyServiceType): Promise<string> {
    if (!input) {
      return "";
    }

    return input.toString();
  }

  public readonly orderStepToString = orderStepToString;
}
